// Non-production build switch.
//
// One flag decides whether a build is a public production build or not:
// VITE_NOINDEX. deploy-stg.yml sets it to 'true'; deploy-prod.yml never sets it.
// Every non-production build must be invisible to search engines and analytics
// (global rule: dev/staging/preview are never indexed or tracked), so this one
// flag drives all of it:
//   - SEOHead stamps <meta name="robots" content="noindex,nofollow"> on pages
//   - the Vite build stamps the same tag into the SPA shell (index.html),
//     replaces robots.txt with "Disallow: /" and drops sitemap.xml
//   - initAnalytics() loads nothing (no Umami, GA4, GTM or Clarity)
//
// Only the exact string 'true' counts, so a typo can never hide the live site.

type Env = Record<string, string | boolean | undefined>

// Pure (env passed in) so vite.config.ts can use it at build time too.
export function isNonProdBuild(env: Env): boolean {
  return env.VITE_NOINDEX === 'true'
}

export const NOINDEX_META_TAG = '<meta name="robots" content="noindex,nofollow" />'

export const NONPROD_ROBOTS_TXT = 'User-agent: *\nDisallow: /\n'

// Adds the noindex tag to an HTML document's <head>. Idempotent.
export function addNoindexMeta(html: string): string {
  if (/<meta name="robots"[^>]*noindex/.test(html)) return html
  return html.replace('</head>', `    ${NOINDEX_META_TAG}\n  </head>`)
}
